/** @module components/drag-and-drop-quiz */


import Model from '@lernetz/ts-lib/src/core/model/Model';
import View from '@lernetz/ts-lib/src/core/view/View';

import {Item} from './Item';

import {CanShowCorrectness} from '../quiz/CanShowCorrectness';

import {TextItem as textItemTemplate} from '../../templates/drag-and-drop-quiz';


/**
 * Specifies the initial state for a [[TextItem]].
 */
export interface TextItemInitialState {

    /**
     * Sets the text that should be rendered for this item.
     */
    text: string;

    /**
     * Sets whether the correctness of the selected choice should be initially shown.
     * Defaults to `false`.
     */
    showCorrectness?: boolean;
}


/**
 * An [[Item]] that shows some text.
 */
export class TextItem extends Model implements Item, CanShowCorrectness {

    /**
     * Gets whether this item is currently placed in the correct drop area.
     */
    public inCorrectDropArea: boolean;

    /** @inheritdoc */
    public showCorrectness: boolean;

    /**
     * Gets the text that should be rendered for this item.
     */
    public readonly text: string;

    /**
     * Initializes a new instance of the [[TextItem]] class.
     *
     * @param initialState Specifies the initial state for the new instance.
     */
    public constructor(initialState: TextItemInitialState, data?: object) {
        super({
            inCorrectDropArea: false,
            showCorrectness: false,
            text: '',
            ...initialState,
            ...data
        })
    }
}


export class TextItemView extends View<TextItem> {

    public constructor() {
        super({ template: textItemTemplate });
    }
}
